import React from 'react';
import { Box, Typography, Chip } from '@curves/ui-base';
import { REWARD_ACTION_TYPE } from '@Constants/dataEnums';
import { parseDate } from '@Util/moment';

const HistoryRecordCard = ({ record }) => {
    // 累點為正向（綠色 +N），其餘（兌點／還點等）為中性
    const isAccumulate = record.actionType === REWARD_ACTION_TYPE.ACCUMULATE;

    return (
        <Box className="history-record-card">
            <Box className="history-card-header">
                <Chip
                    label={record.actionTypeText}
                    size="small"
                    className={`history-type-chip ${isAccumulate ? 'chip-accumulate' : 'chip-redeem'}`}
                />
                {/* 紀錄卡片只需月日與時分（24 小時制） */}
                <Typography className="history-date">{parseDate(record.recordDate, 'M/D HH:mm')}</Typography>
            </Box>
            <Box className="history-card-body">
                <ul className="history-desc">
                    {record.desc.map((line, i) => (
                        <li key={i} className="history-desc-line">{line}</li>
                    ))}
                </ul>
                <Typography className={`history-points ${isAccumulate ? 'points-positive' : 'points-neutral'}`}>
                    {isAccumulate ? `+${record.points}` : record.points} 點
                </Typography>
            </Box>
        </Box>
    );
};

export default HistoryRecordCard;
